// ADD_ABOUT_DATA
export const addAboutData = (data) => ({
    type: 'ADD_ABOUT_DATA',
    data
  });


// WEBPACK FOOTER //
// ./src/actions/about.js